import { render } from "./computer-component.vue?vue&type=template&id=91fa336e&scoped=true&ts=true"
import script from "./computer-component.vue?vue&type=script&lang=ts"
export * from "./computer-component.vue?vue&type=script&lang=ts"

import "./computer-component.vue?vue&type=style&index=0&id=91fa336e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91fa336e"]])

export default __exports__